export { PostCallViewAdaptive as default } from "../../../navigation/ResponsiveScreens";
